if (!customElements.get('swiper-credits')) {
  customElements.define(
    'swiper-credits',
    class SwiperCredits extends HTMLElement {
      constructor() {
        super();
        this._handlers = {};
      }

      connectedCallback() {
        this._motionReduced = FoxTheme.config && FoxTheme.config.motionReduced;
        FoxTheme.Motion.inView(this, this._initSlider.bind(this), { margin: '200px 0px 200px 0px' });
      }

      disconnectedCallback() {
        if (this._swiper) {
          this._swiper.destroy(true, true);
          this._swiper = null;
        }
        if (this._designHandler) {
          this.removeEventListener('shopify:block:select', this._designHandler);
          this._designHandler = null;
        }
        if (this._pollTimer) {
          clearTimeout(this._pollTimer);
          this._pollTimer = null;
        }
      }

      _initSlider() {
        var slides = this.querySelectorAll('.swiper-slide');
        if (slides.length < 2) return;

        if (!window.FoxTheme || !FoxTheme.Swiper) {
          this._pollTimer = setTimeout(this._initSlider.bind(this), 100);
          return;
        }

        var self = this;
        var autoplay = this.hasAttribute('autoplay');
        var delay = autoplay ? parseInt(this.getAttribute('autoplay-speed')) * 1000 : 5000;
        var ready = false;

        slides.forEach(function (slide) {
          if (!slide.classList.contains('swiper-slide-active')) self._resetMotion(slide);
        });

        this._swiper = new FoxTheme.Swiper.Swiper(this, {
          modules: [FoxTheme.Swiper.Autoplay, FoxTheme.Swiper.A11y],
          loop: true,
          allowTouchMove: false,
          speed: 0,
          autoplay: autoplay ? { delay: delay, pauseOnMouseEnter: true, disableOnInteraction: false } : false,
          on: {
            init: function () {
              requestAnimationFrame(
                function () {
                  self._playMotion(this.slides[this.activeIndex]);
                  ready = true;
                }.bind(this),
              );
            },
            slideChange: function () {
              if (!ready) return;
              this.slides.forEach(function (s) {
                self._resetMotion(s);
              });
              var active = this.slides[this.activeIndex];
              if (active) {
                requestAnimationFrame(function () {
                  self._playMotion(active);
                });
              }
            },
          },
        });

        if (Shopify.designMode) {
          this._designHandler = function (e) {
            var idx = parseInt(e.target.dataset.index);
            if (!isNaN(idx) && self._swiper) self._swiper.slideToLoop(idx);
          };
          this.addEventListener('shopify:block:select', this._designHandler);
        }
      }

      _resetMotion(slide) {
        if (this._motionReduced || !slide) return;
        slide.querySelectorAll('motion-element').forEach(function (el) {
          if (el && el.resetAnimation) el.resetAnimation();
        });
      }

      _playMotion(slide) {
        if (this._motionReduced || !slide) return;
        slide.querySelectorAll('motion-element').forEach(function (el) {
          if (el && el.refreshAnimation) el.refreshAnimation();
        });
      }
    },
  );
}

if (!customElements.get('credits-mobile')) {
  customElements.define(
    'credits-mobile',
    class CreditsMobile extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        var self = this;
        var track = this.querySelector('.credits-mobile__track');
        if (!track) return;

        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        var slides = track.querySelectorAll('.credits-mobile__slide');
        slides.forEach(function (slide) {
          var clone = slide.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.classList.add('credits-mobile__slide--clone');
          track.appendChild(clone);
        });

        var speed = parseInt(this.dataset.autoplaySpeed) || 15;
        this.style.setProperty('--credits-speed', speed + 's');
        this.classList.toggle('__reduced-motion', reduced);

        this._onEnter = function () {
          self.classList.add('__paused');
        };
        this._onLeave = function () {
          self.classList.remove('__paused');
        };
        this.addEventListener('mouseenter', this._onEnter);
        this.addEventListener('mouseleave', this._onLeave);

        this._mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._onMqChange = function (e) {
          self.classList.toggle('__reduced-motion', e.matches);
        };
        this._mq.addEventListener('change', this._onMqChange);
      }

      disconnectedCallback() {
        if (this._onEnter) this.removeEventListener('mouseenter', this._onEnter);
        if (this._onLeave) this.removeEventListener('mouseleave', this._onLeave);
        if (this._mq) {
          this._mq.removeEventListener('change', this._onMqChange);
          this._mq = null;
        }
      }
    },
  );
}
